module.exports = __webpack_public_path__ + "img/switchOn2x.png?f3499cd77bdf6606c4dac7165f4f76c4";